import script from "./Authorize.vue?vue&type=script&setup=true&lang=js"
export * from "./Authorize.vue?vue&type=script&setup=true&lang=js"

import "./Authorize.vue?vue&type=style&index=0&id=5f834b80&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f834b80"]])

export default __exports__